<template>
  <div class="contents-area" v-scroll="nextPage" >
    <div
      class="otaku-item"
      v-for="(val, key, index) in contents"
      :key="index"
      :style="`background-image: url(${val.img1})`"
      @click="moveDetail(val.id)"
    >
      <div v-if="val.is_done==1" class="sold">sold</div>
      <div class="price-label">{{val.price}} JPY</div>
      <div class="name-label">
        <p>{{val.name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Market',

  props: [
    'api',
  ],

  data() {
    return {
      contents: [],
      page: 1,
      lastPage: 1,
      clientHeight: 0,
      isLoading: true,
      isLoadingPage: false,
      tag: {
        m: "maker",
        c: "character",
        t: "content_title",
      }
    };
  },

  created() {
    this.getContent()
    if(Object.keys(this.$route.query).length) {
      this.getTagInfo()
    }
  },

  watch: {
    '$route' (to, from) {
      this.getContent()
    },
  },


  methods: {
    getContent() {
      axios.get(`private/${this.api}s/search`, {
        params: this.$route.query
      }).then((data) => {
        this.lastPage = Math.ceil(data.data.result.countNum / 20)
        this.contents = data.data.result.model
        this.isLoading = false
        this.getHeight()
      }).catch((err) => {
        console.log(err)
      })
    },

    getTagInfo() {
      if(this.$route.query) {
        let whichQuery = Object.keys(this.$route.query)
        axios.get(`private/${this.tag[whichQuery[0]]}/tag/${this.$route.query[whichQuery[0]]}`)
        .then(data => {
          //タグの言語対応状況と自分の言語を評価
          //switchの方がキレイかも
          if(data.data.result.en !== null && this.$store.state.account.lang === 'en') {
            this.$parent.tagName = data.data.result['en']
          } else if(data.data.result.ja !== null && this.$store.state.account.lang === 'ja') {
            this.$parent.tagName = data.data.result['ja']
          } else if(data.data.result.ja !== null && data.data.result.en == null) {
            this.$parent.tagName = data.data.result['ja']
          } else {
            this.$parent.tagName = data.data.result['en']
          }

        }).catch(err => {
          console.log(err)
        })
      }
    },

    getHeight() {
      this.$nextTick(() => {
        let pageEl = document.querySelector('.contents-area')
        this.pageHeight = pageEl.clientHeight
      })
    },

    nextPage(evt, el) {
      //読み込み中は動作させない
      let scrollY = window.scrollY + window.innerHeight
      if(this.isLoadingPage) {return false}
      if(scrollY >= this.pageHeight) {
        this.isLoadingPage = true
        //最終ページじゃないかのチェック
        if(this.page < this.lastPage) {
          this.page++
        } else {
          this.isLoadingPage = false
          return false
        }
        this.$route.query.page = this.page

        axios.get('private/requests/search', {
          params: this.$route.query
        }).then((data) => {
          data.data.result.model.map(newRequest => {
            this.contents.push(newRequest)
          })
          this.getHeight()
          this.isLoadingPage = false
        }).catch((err) => {
          console.log(err)
        })
      }
    },

    moveDetail(id) {
      this.$router.push(`/${this.api}/${id}`)
    },
  },
}


</script>
<style scoped>

.search-wrapper {
  width: 100%;
  margin: 10px;
  border-bottom: 1px solid #e9ecef;
}

.search-text {
  width: 100%;
}

.requests-area{
  position: static;
  margin-bottom: 70%;
}

.price-label {
  position: absolute;
  bottom: 25%;
  font-size: 16px;
  right: 0px;
  background: rgba(0, 0, 0 ,0.7);
  color: #fff;
  padding: 0 10px;
  border-radius: 5px 0 0 5px;
}

@media screen and (min-width: 800px){
  .price-label {
    bottom: 45px;
    font-size: 14px;
  }

  .search-text {
    padding: 0;
    border: none;
    border-radius: 0;
    outline: none;
    background: none;
    font-size: 18px;
  }

  .requests-area{
    margin-bottom: 10%;
  }

}
</style>
